// extracted by mini-css-extract-plugin
module.exports = {"notbox":"Notification_notbox__3OtGm","container":"Notification_container__2Ycj5","button":"Notification_button__evLWX"};